<div class="card bg-light">
    <div class="card-header">Customer comments</div>
    <div class="card-body order-details">
        <form [formGroup]="customerNotesForm" *ngIf="isEditMode; else notesTemplate">
            <div class="form-group row">
                <div class="col-12">
                    <div class="input-group is-invalid">
                        <textarea
                            class="form-control"
                            rows="3"
                            placeholder="Enter some notes"
                            formControlName="notes"
                        >
                        </textarea>
                    </div>
                    <div
                        *ngIf="isSubmitted && fields.notes.errors"
                        class="invalid-feedback"
                    >
                        <div *ngIf="fields.notes.errors.required">
                            Customer notes is required
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <ng-template #notesTemplate>
            {{ notes }}
        </ng-template>
    </div>
    <div class="card-footer bg-secondary">
        <div class="btn-group" role="group">
            <button
                *ngIf="!isEditMode"
                type="button"
                class="btn btn-warning"
                (click)="isEditMode = !isEditMode"
            >
                Edit
            </button>
            <button
                *ngIf="isEditMode"
                type="button"
                class="btn btn-primary"
                (click)="updateCustomerNotes()"
            >
                Save
            </button>
            <button
                *ngIf="isEditMode"
                type="button"
                class="btn btn-danger"
                (click)="isEditMode = !isEditMode"
            >
                Cancel
            </button>
        </div>
    </div>
</div>
